import axios from "axios";
import Config from "../../../config";

const v2_actionSalvarLayoutConfig = (clienteId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/crm/layout-config`,
        data
    });
};

export default v2_actionSalvarLayoutConfig;
